import React from 'react'
import Intro from './Intro'
import Services from './Services'
import Benifits from './Benifits'
import WhereWeUse from './WherWeUse'
import Awards from './Awards'
import Contact from '../../../ContactForm/ContactUs'
const Office24by7 = () => {
  return (
    <div>
      <Intro />
      <Services />
      <Benifits />
      <WhereWeUse />
      <Awards />
      <Contact/>
    </div>
  )
}

export default Office24by7
